import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ClassProgress } from "./ClassProgress";
import type { JpClassAttendanceStaff } from "./JpClassAttendanceStaff";
import type { JpClassSignupDTOBase } from "./JpClassSignupDTOBase";
import type { JpClassStaff } from "./JpClassStaff";
import type { JpClassWlResultStaff } from "./JpClassWlResultStaff";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedBase } from "./TrackedBase";

export class JpClassSignupStaff implements JpClassSignupDTOBase, TrackedBase {
  constructor(public readonly signupId: number, public readonly signupDatetime: Date | null, public readonly sequence: number | null, public readonly signupType: string | null, public readonly groupId: number | null, public readonly isReserve: string | null, public readonly ccTransNum: string | null, public readonly closeId: number | null, public readonly discountInstanceId: number | null, public readonly orderId: number | null, public readonly paymentMedium: string | null, public readonly price: number | null, public readonly voidCloseId: number | null, public readonly signupNote: string | null, public readonly ignoreIllegalSignup: string | null, public readonly staggerId: number | null, public readonly parentSignupNote: string | null, public readonly sectionLookupId: number | null, public readonly compassOrderID: number | null, public readonly sectionId: number | null, public readonly classProgress: ClassProgress, public readonly wlResult: JpClassWlResultStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly instanceId: JpClassStaff | null, public readonly personId: PersonStaff | null, public readonly attendance: Array<JpClassAttendanceStaff> | null) {
    this.cbiServiceContext = null;
    this.wlResultLoaded = this.wlResult != null;
    this.wlResultCached = this.wlResult;
    this.instanceIdLoaded = this.instanceId != null;
    this.instanceIdCached = this.instanceId;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.attendanceLoaded = this.attendance != null;
    this.attendanceCached = this.attendance;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private wlResultLoaded: boolean;
  private wlResultCached: JpClassWlResultStaff | null;
  private instanceIdLoaded: boolean;
  private instanceIdCached: JpClassStaff | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private attendanceLoaded: boolean;
  private attendanceCached: Array<JpClassAttendanceStaff> | null;
  async wlResultLazy(): Promise<JpClassWlResultStaff | null> {
    if (!this.wlResultLoaded) {
      this.wlResultCached = await this.cbiServiceContext!.jpClassService().getJpClassSignupStaffWlResult(this.signupId);
      this.wlResultLoaded = true;
    }
    return this.wlResultCached;
  }
  async instanceIdLazy(): Promise<JpClassStaff> {
    if (!this.instanceIdLoaded) {
      this.instanceIdCached = await this.cbiServiceContext!.jpClassService().getJpClassSignupStaffInstanceId(this.signupId);
      this.instanceIdLoaded = true;
    }
    return this.instanceIdCached!;
  }
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.jpClassService().getJpClassSignupStaffPersonId(this.signupId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async attendanceLazy(): Promise<Array<JpClassAttendanceStaff>> {
    if (!this.attendanceLoaded) {
      this.attendanceCached = await this.cbiServiceContext!.jpClassService().getJpClassSignupStaffAttendance(this.signupId);
      this.attendanceLoaded = true;
    }
    return this.attendanceCached!;
  }
}
